<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="filteredModules"
        :items-per-page="10"
        class="elevation-0 custom-data-table"
        :no-data-text="noDataText"
        :height="tableHeight"
        fixed-header
        :loading="tableLoading"
        density="compact"
      >
        <template #top>
          <div
            class="d-flex justify-space-between align-center pa-4 flex-wrap"
            style="gap: 12px"
          >
            <span class="text-h5">Support Modules</span>
            <div class="d-flex align-center flex-wrap" style="gap: 12px">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                variant="outlined"
                density="compact"
                style="width: 280px; max-width: 100%"
              />
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="showCreateDialog = true"
              >
                Add Module
              </v-btn>
            </div>
          </div>
        </template>

        <template #[`item.module_name`]="{ item }">
          <span class="font-weight-medium">{{ item.module_name }}</span>
        </template>

        <template #[`item.module_status`]="{ item }">
          <v-chip
            size="small"
            :color="isModuleActive(item) ? 'success' : 'grey'"
            variant="tonal"
          >
            {{ isModuleActive(item) ? "Active" : "Inactive" }}
          </v-chip>
        </template>

        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-center" style="gap: 4px">
            <v-btn
              icon
              size="small"
              variant="text"
              color="primary"
              @click="openEditDialog(item)"
            >
              <v-icon>mdi-pencil</v-icon>
              <v-tooltip activator="parent" location="top">Edit</v-tooltip>
            </v-btn>
            <v-btn
              icon
              size="small"
              variant="text"
              color="error"
              :disabled="!isModuleActive(item)"
              @click="openDeleteDialog(item)"
            >
              <v-icon>mdi-delete</v-icon>
              <v-tooltip activator="parent" location="top">Delete</v-tooltip>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <CreateModule v-model="showCreateDialog" @created="handleModuleCreated" />

    <EditModule
      v-model="showEditDialog"
      :module_id="selectedModule?.module_id || ''"
      :module_name="selectedModule?.module_name || ''"
      :module_status="selectedModule?.module_status || 'ACTIVE'"
      @updated="handleModuleUpdated"
    />

    <DeleteModule
      v-model="showDeleteDialog"
      :module="selectedModule"
      @deleted="handleModuleDeleted"
    />
  </div>
</template>

<script>
import CreateModule from "@/components/SupportModule/CreateModule.vue";
import EditModule from "@/components/SupportModule/EditModule.vue";
import DeleteModule from "@/components/SupportModule/DeleteModule.vue";
import SupportModuleApi from "@/mixins/RCSSupport/SupportModuleApi";

export default {
  name: "ListModule",
  mixins: [SupportModuleApi],
  components: {
    CreateModule,
    EditModule,
    DeleteModule,
  },
  data() {
    return {
      showCreateDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      selectedModule: null,
      search: "",
      tableLoading: false,
      windowHeight: window.innerHeight,
      headers: [
        { title: "Module Name", key: "module_name", sortable: true },
        {
          title: "Status",
          key: "module_status",
          sortable: true,
          width: "120px",
        },
        {
          title: "Actions",
          key: "actions",
          sortable: false,
          align: "center",
          width: "120px",
        },
      ],
      modules: [],
    };
  },
  computed: {
    noDataText() {
      return "No support modules found.";
    },
    tableHeight() {
      return Math.max(320, this.windowHeight - 220);
    },
    filteredModules() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.modules;
      return this.modules.filter((module) =>
        [module.module_name, module.module_status]
          .join(" ")
          .toLowerCase()
          .includes(q)
      );
    },
  },
  async mounted() {
    window.addEventListener("resize", this.onResize);
    await this.loadModules();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    isModuleActive(module) {
      return String(module?.module_status || "").toUpperCase() === "ACTIVE";
    },
    async loadModules() {
      this.tableLoading = true;
      try {
        await this.fetchModules();
        this.modules = this.modulesList;
      } catch (error) {
        console.error("Error loading support modules:", error);
        this.modules = [];
      } finally {
        this.tableLoading = false;
      }
    },
    async handleModuleCreated() {
      await this.loadModules();
    },
    openEditDialog(module) {
      this.selectedModule = module;
      this.showEditDialog = true;
    },
    openDeleteDialog(module) {
      this.selectedModule = module;
      this.showDeleteDialog = true;
    },
    async handleModuleUpdated() {
      this.selectedModule = null;
      await this.loadModules();
    },
    async handleModuleDeleted() {
      this.selectedModule = null;
      await this.loadModules();
    },
  },
};
</script>
